import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import background from "../../assets/images/Rectangle-background.svg";
import "../Portfolio.css";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import MediaQuery from "react-responsive";

import img1 from "../../assets/images/portfolio/esoma/register.png";
import img2 from "../../assets/images/portfolio/esoma/school-registration.png";
import img3 from "../../assets/images/portfolio/esoma/classroom2.png";
import img4 from "../../assets/images/portfolio/discord-feud/index.png";
import img5 from "../../assets/images/portfolio/discord-feud/pic6.png";
import img6 from "../../assets/images/portfolio/PNT-Clothing/login.png";
import img7 from "../../assets/images/portfolio/PNT-Clothing/shop.png";
import img10 from "../../assets/images/portfolio/PNT-Clothing/admin-stats.png";
import img8 from "../../assets/images/portfolio/strath-booking/updates.png";
import img9 from "../../assets/images/portfolio/two-of-us/articles.png";

const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10];
shuffleArray(images);

function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}
function Carousel() {
  let navigate = useNavigate();

  const handleClick = () => {
    navigate("/portfolio");
  };

  const NextArrow = ({ onClick }) => {
    return (
      <div className="arrow next" onClick={onClick}>
        <MdArrowForwardIos
          size={50}
          className="fill-cool-300 hover:fill-cool-200"
        />
      </div>
    );
  };

  const PrevArrow = ({ onClick }) => {
    return (
      <div className="arrow prev" onClick={onClick}>
        <MdArrowBackIos
          size={50}
          className="fill-cool-300 hover:fill-cool-200"
        />
      </div>
    );
  };

  const [imageIndex, setImageIndex] = useState(0);
  const sliderSettings = {
    infinite: true,
    lazyLoad: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: "linear",
    centerMode: true,
    centerOadding: 0,
    adaptiveHeight: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (current, next) => setImageIndex(next),
  };

  const sliderSettingsMobile = {
    infinite: true,
    lazyLoad: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: "linear",
    centerMode: true,
    centerOadding: 0,
    adaptiveHeight: false,
    nextArrow: false,
    prevArrow: false,
    beforeChange: (current, next) => setImageIndex(next),
  };

  return (
    <div className="">
      <MediaQuery maxWidth={870}>
        <Slider {...sliderSettingsMobile} className="">
          {images.map((img, idx) => (
            <div
              key={idx}
              className={idx === imageIndex ? "slide activeSlide" : "slide"}
            >
              <img src={img} alt={img} />
            </div>
          ))}
        </Slider>
      </MediaQuery>

      <MediaQuery minWidth={870}>
        <Slider {...sliderSettings} className="">
          {images.map((img, idx) => (
            <div
              key={idx}
              className={idx === imageIndex ? "slide activeSlide" : "slide"}
            >
              <img src={img} alt={img} />
            </div>
          ))}
        </Slider>
      </MediaQuery>
    </div>
  );
}

export default Carousel;
